import { Action } from 'redux';
import { Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { LOAD_INTERNAL_MARKETERS } from '../../../actions/marketers/internal/loadInternalMarketers';
import {
    UpdateInternalMarketers,
    updateInternalMarketersAction
} from '../../../actions/marketers/internal/updateInternalMarketers';
import {
    UpdateInternalMarketersPageStatus,
    updateInternalMarketersPageStatusAction
} from '../../../actions/marketers/internal/updateInternalMarketersPageStatus';
import {
    UpdateInternalProductPlaces,
    updateInternalProductPlacesAction
} from '../../../actions/places/internal/updateInternalProductPlaces';
import {
    UpdateInternalProducts,
    updateInternalProductsAction
} from '../../../actions/products/internal/updateInternalProducts';
import { selectMarketersSortParams } from '../../../selectors/marketers';
import { EpicDeps } from '../../../service/StoreFactory';
import { MarketersPageStates } from '../../../typings/marketers';
import { State } from '../../../typings/state';

type EpicActions =
    | UpdateInternalMarketers
    | UpdateInternalMarketersPageStatus
    | UpdateInternalProductPlaces
    | UpdateInternalProducts;

export const loadInternalMarketersEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(LOAD_INTERNAL_MARKETERS),
        mergeMap(
            (): Observable<EpicActions> => {
                return from(
                    Promise.all([
                        deps.productsDataProvider.getPlaces(),
                        deps.productsDataProvider.getList(),
                        deps.marketersDataProvider.getList()
                    ])
                ).pipe(
                    mergeMap(([places, products, marketers]) => {
                        const sortParams = selectMarketersSortParams(store$.value);

                        return of(
                            updateInternalProductPlacesAction(places),
                            updateInternalProductsAction(products),
                            updateInternalMarketersAction(marketers, sortParams),
                            updateInternalMarketersPageStatusAction(MarketersPageStates.LOADED)
                        );
                    }),
                    catchError(() => of(updateInternalMarketersPageStatusAction(MarketersPageStates.ERROR)))
                );
            }
        )
    );
};
